import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">作文素材分类</h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            按主题分类浏览，快速找到你需要的写作灵感和范文素材
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400">
                {cat.count} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}